import React, { useContext, useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Link, FormControlLabel, Radio, CircularProgress, Tooltip, Select, MenuItem, FormControl, InputAdornment, TextField, Button, TableContainer, Table, TableHead, TableBody, Paper, TablePagination, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { post } from '../../../services/http';
import { ContextSession } from "../../../services/ContextSession";
import FilterListIcon from '@mui/icons-material/FilterList';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import { useNavigate } from 'react-router-dom';

async function getSolicitudes(accesos, ip) {
    let json = { data: "null" };
    let url = "https://be.injupemp.gob.hn:8443/api/resumen/";
    //let url = "http://172.20.7.10:8082/api/resumen/";

    let auto = "Bearer " + accesos;

    let datas = await post(url, json, auto);
    console.log("LA DATA DE LA TABLA ES: ", datas);
    return datas;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#19438C',
        color: 'white',
        fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        borderRight: 'none', // Elimina la línea vertical entre columnas
        borderLeft: 'none', // Elimina la línea vertical entre columnas
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '&:hover': { // Agrega estilo al pasar el cursor sobre la fila
        backgroundColor: '#C1C1C1', // Cambia el color de fondo al pasar el cursor
    },
}));

function HistorialPreanalisis() {
    const [users, setUsers] = useState([]);
    let sessi = useContext(ContextSession);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [searchTerm, setSearchTerm] = useState('');
    const [loanType, setLoanType] = useState('');
    const [monthFilter, setMonthFilter] = useState('');
    const [yearFilter, setYearFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [statusSolicitudFilter, setStatusSolicitudFilter] = useState('');
    const [filas, setFilas] = useState([]);
    const [selectedSolicitudID, setSelectedSolicitudID] = useState(null);
    const navigate = useNavigate();

    const fetchUsers = async (ip) => {
        try {
            const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/auth/oficiales`, {
                method: 'GET', // Cambia el método a POST
                headers: {
                    'Content-Type': 'application/json', // Define el tipo de contenido si es necesario
                    // 'Authorization': `Bearer ${tuToken}`, // Si necesitas autenticar la solicitud
                },
            });

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error al obtener usuarios:', error);
            return [];
        }
    };

    useEffect(() => {
        fetchUsers(sessi.ip).then((data) => setUsers(data));
    }, []);

    useEffect(() => {
        async function fetchData() {
            let token = sessi.sessionData.token;
            const data = await getSolicitudes(token, sessi.ip);
            // Ordenar las filas
            const sortedData = data.sort((a, b) => {
                // Primero, priorizar solicitudes "Sin Revisar"
                const aSinRevisar = ![1, 2, 3, 5, 6, 7].includes(a.aprobado);
                const bSinRevisar = ![1, 2, 3, 5, 6, 7].includes(b.aprobado);
                if (aSinRevisar && !bSinRevisar) {
                    return -1;
                }
                if (!aSinRevisar && bSinRevisar) {
                    return 1;
                }

                // Primero, ordenar por estado
                if (a.asignado === null && b.asignado !== null) {
                    return -1; // 'Sin Asignar' debe ir antes que 'Asignado'
                }
                if (a.asignado !== null && b.asignado === null) {
                    return 1;
                }
                // Luego, ordenar por fecha de solicitud (más antigua primero)
                return new Date(a.FechaSolicitud) - new Date(b.FechaSolicitud);
            });
            setFilas(sortedData);
            setLoading(false);
        }
        fetchData();
    }, [sessi.sessionData.token, sessi.ip]);


    useEffect(() => {
        async function fetchData() {
            try {
                let token = sessi.sessionData.token;
                const response = await getSolicitudes(token, sessi.ip);
                if (response.ok) {
                    const data = await response.json();
                    setFilas(data);
                } else {
                    console.error('Error al obtener datos:', response.status, response.statusText);
                }
                setLoading(false);
            } catch (error) {
                console.error('Error al obtener datos:', error);
            }
        }
        fetchData();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        const searchTerm = event.target.value;
        setSearchTerm(searchTerm);
    };

    const handleLoanTypeChange = (event) => {
        setLoanType(event.target.value);
    };

    const handleMonthChange = (event) => {
        setMonthFilter(event.target.value);
        setPage(0);
    };

    const handleYearChange = (event) => {
        setYearFilter(event.target.value);
        setPage(0);
    };

    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };

    const handleStatusSolicitudChange = (event) => {
        setStatusSolicitudFilter(event.target.value);
    };

    const [currentAssignedUserId, setCurrentAssignedUserId] = useState(null);

    const handleClickCarga = (id, oficialAsignado) => {
        sessi.setVariable("SolicitudPrestamo", id);
        sessi.setVariable("OficialAsignado", oficialAsignado);
        navigate(`/PortalDelParticipante/SolicitudesCargaPreAnalisisJefe`);
    };

    const monthOptions = [
        { value: '1', label: 'Enero' },
        { value: '2', label: 'Febrero' },
        { value: '3', label: 'Marzo' },
        { value: '4', label: 'Abril' },
        { value: '5', label: 'Mayo' },
        { value: '6', label: 'Junio' },
        { value: '7', label: 'Julio' },
        { value: '8', label: 'Agosto' },
        { value: '9', label: 'Septiembre' },
        { value: '10', label: 'Octubre' },
        { value: '11', label: 'Noviembre' },
        { value: '12', label: 'Diciembre' },
    ];

    const availableYears = [...new Set(
        filas
            .map((row) => {
                const fecha = new Date(row.FechaSolicitud);
                if (Number.isNaN(fecha.getTime())) return null;
                return String(fecha.getFullYear());
            })
            .filter(Boolean)
    )].sort((a, b) => Number(b) - Number(a));

    const filteredRows = filas.filter((row) => {
        // Determina el estado de la solicitud
        const status = row.aprobado === 1 ? 'Pre Aprobado' :
            row.aprobado === 2 ? 'Pre Aprobado Sujeto A Cambios' :
                row.aprobado === 3 ? 'Rechazado' :
                    row.aprobado === 6 ? 'Rechazado' :
                        row.aprobado === 7 ? 'Aprobado Sujeto A Cambios' :
                            'Sin Revisar';

        // Determina si la solicitud está asignada o no
        const asignadoStatus = row.asignado !== null ? 'Asignado' : 'Sin Asignar';

        // Normaliza valores para búsqueda insensible a mayúsculas/minúsculas
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        const fechaSolicitud = new Date(row.FechaSolicitud);
        const isValidFechaSolicitud = !Number.isNaN(fechaSolicitud.getTime());
        const matchesMonth =
            monthFilter === '' ||
            (isValidFechaSolicitud && String(fechaSolicitud.getMonth() + 1) === monthFilter);
        const matchesYear =
            yearFilter === '' ||
            (isValidFechaSolicitud && String(fechaSolicitud.getFullYear()) === yearFilter);

        // Filtrar filas basándose en los criterios combinados
        return (
            //status === 'Sin Revisar' && asignadoStatus === 'Asignado' && // Filtro por estado y asignación
            (loanType === '' || row.TipoPrestamo === loanType) && // Filtro por tipo de préstamo
            matchesMonth &&
            matchesYear &&
            (
                searchTerm === '' || // Si no hay búsqueda activa, incluye todas las filas válidas
                (row.NumeroSolicitud?.toString().toLowerCase().includes(lowerCaseSearchTerm) || // Búsqueda por número de solicitud
                    (row.solicitante && row.solicitante[0] && (
                        row.solicitante[0].Nombres?.toLowerCase().includes(lowerCaseSearchTerm) || // Búsqueda por nombre del solicitante
                        row.solicitante[0].Apellidos?.toLowerCase().includes(lowerCaseSearchTerm)
                    )) ||
                    row.TipoPrestamo?.toLowerCase().includes(lowerCaseSearchTerm)) // Búsqueda por tipo de préstamo
            )
        );
    });


    const [anchorEl, setAnchorEl] = useState(null);
    const [filterType, setFilterType] = useState('');

    const handleFilterClick = (event, type) => {
        setAnchorEl(event.currentTarget);
        setFilterType(type);
    };

    const handleFilterClose = () => {
        setAnchorEl(null);
        setFilterType('');
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div className="container" style={{ marginTop: 10 }}>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                        <h2><b>Historial de Preanálisis de Préstamos en INJUPEMP Conectados</b></h2>
                    </div>

                    <div className="row" style={{ marginTop: '20px' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell style={{ textAlign: 'center' }}>#</StyledTableCell>
                                        <StyledTableCell >
                                            <div>
                                                <strong>No. Solicitud</strong>
                                                <Tooltip title="Buscar por Solicitud" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                                                        <ManageSearchIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <div>
                                                <strong>Nombre del Solicitante</strong>
                                                <Tooltip title="Buscar por Nombre" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                                                        <ManageSearchIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <div>
                                                <strong>Tipo De Préstamo</strong>
                                                <Tooltip title="Filtrar por Tipo" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'loanType')}>
                                                        <FilterListIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <div>
                                                <strong>Fecha Solicitud</strong>
                                                <Tooltip title="Filtrar por Mes y Año" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'date')}>
                                                        <FilterListIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <div>
                                                <strong>Analista Asignado</strong>
                                                {/*<Tooltip title="Filtrar por Analista" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'status')}>
                                                        <FilterListIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>*/}
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <strong>Estado Solicitud</strong>
                                            {/*<Tooltip title="Filtrar por Estado" arrow>
                                                <IconButton onClick={(event) => handleFilterClick(event, 'statusSolicitud')}>
                                                    <FilterListIcon style={{ color: 'white' }} />
                                                </IconButton>
                                            </Tooltip>*/}
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>
                                            <strong>Acciones</strong>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>

                                <Popover
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleFilterClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                >
                                    {filterType === 'search' && (
                                        <TextField
                                            placeholder="Realizar Búsqueda"
                                            aria-label="Search"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                    {filterType === 'loanType' && (
                                        <FormControl>
                                            <Select
                                                value={loanType}
                                                onChange={handleLoanTypeChange}
                                                displayEmpty
                                            >
                                                <MenuItem value=""><em>Todos los tipos</em></MenuItem>
                                                <MenuItem value="Sin Aval">Sin Aval</MenuItem>
                                                <MenuItem value="Con Aval">Con Aval</MenuItem>
                                                <MenuItem value="Consolidacion de Deuda">Consolidacion de Deuda</MenuItem>
                                                <MenuItem value="Alivio de Deuda">Alivio de Deuda</MenuItem>
                                                <MenuItem value="Refinanciamiento">Refinanciamiento</MenuItem>
                                                <MenuItem value="Hipotecario">Hipotecario</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                    {filterType === 'date' && (
                                        <Box sx={{ p: 1, minWidth: 220, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <FormControl size="small">
                                                <Select
                                                    value={monthFilter}
                                                    onChange={handleMonthChange}
                                                    displayEmpty
                                                >
                                                    <MenuItem value=""><em>Todos los meses</em></MenuItem>
                                                    {monthOptions.map((month) => (
                                                        <MenuItem key={month.value} value={month.value}>
                                                            {month.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <FormControl size="small">
                                                <Select
                                                    value={yearFilter}
                                                    onChange={handleYearChange}
                                                    displayEmpty
                                                >
                                                    <MenuItem value=""><em>Todos los años</em></MenuItem>
                                                    {availableYears.map((year) => (
                                                        <MenuItem key={year} value={year}>
                                                            {year}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    )}
                                    {filterType === 'status' && (
                                        <FormControl>
                                            <Select
                                                value={statusFilter}
                                                onChange={handleStatusChange}
                                                displayEmpty
                                            >
                                                <MenuItem value=""><em>Todos</em></MenuItem>
                                                <MenuItem value="Sin Asignar">Sin Asignar</MenuItem>
                                                <MenuItem value="Asignado">Asignado</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                    {filterType === 'statusSolicitud' && (
                                        <FormControl>
                                            <Select
                                                value={statusSolicitudFilter}
                                                onChange={handleStatusSolicitudChange}
                                                displayEmpty
                                            >
                                                <MenuItem value=""><em>Todos</em></MenuItem>
                                                <MenuItem value="Sin Revisar">Sin Revisar</MenuItem>
                                                <MenuItem value="Pre Aprobado">Pre Aprobado</MenuItem>
                                                <MenuItem value="Pre Aprobado Sujeto A Cambios">Pre Aprobado Sujeto A Cambios</MenuItem>
                                                <MenuItem value="Rechazado">Rechazado</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                </Popover>

                                <TableBody>
                                    {filteredRows.length > 0 ? (
                                        (rowsPerPage > 0
                                            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            : filteredRows
                                        ).map((row) => (
                                            <StyledTableRow key={row.SolicitudID}>
                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    {row.SolicitudID !== null && row.SolicitudID !== undefined && row.SolicitudID}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {row.NumeroSolicitud !== null && row.NumeroSolicitud !== undefined && row.NumeroSolicitud}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {row.solicitante && row.solicitante[0] && row.solicitante[0].Nombres && row.solicitante[0].Apellidos && `${row.solicitante[0].Nombres} ${row.solicitante[0].Apellidos}`}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {row.TipoPrestamo !== null && row.TipoPrestamo !== undefined && row.TipoPrestamo}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {row.FechaSolicitud !== null && row.FechaSolicitud !== undefined && row.FechaSolicitud.slice(0, 10)}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {
                                                        row.asignado !== null && row.asignado !== undefined
                                                            ? (users.find(user => user.id === row.asignado)?.nombre || "Usuario no encontrado")
                                                            : "Sin Asignar"
                                                    }
                                                </StyledTableCell>

                                                <StyledTableCell style={{ textAlign: 'center' }}>
                                                    <span
                                                        style={{
                                                            backgroundColor:
                                                                row.aprobado === 1 ? '#C6F7D0' :
                                                                    row.aprobado === 2 ? '#f0b70c' :
                                                                        row.aprobado === 3 ? '#FE0000' :
                                                                            row.aprobado === 5 ? '#C6F7D0' :
                                                                                row.aprobado === 6 ? '#FE0000' :
                                                                                    row.aprobado === 7 ? '#C6F7D0' : '#fcfc00',
                                                            borderRadius: 10,
                                                            color: row.aprobado === 3 ? 'white' : 'black',
                                                            padding: 10,
                                                            width: '150px',  // Establece el ancho fijo deseado
                                                            display: 'inline-block',  // Asegura que el ancho se aplique correctamente
                                                        }}
                                                    >
                                                        {row.aprobado === 1 ? 'Pre Aprobado' :
                                                            row.aprobado === 2 ? 'Pre Aprobado Sujeto A Cambios' :
                                                                row.aprobado === 3 ? 'Rechazado' :
                                                                    row.aprobado === 5 ? 'Aprobado' :
                                                                        row.aprobado === 6 ? 'Rechazado' :
                                                                            row.aprobado === 7 ? 'Aprobado Sujeto A Cambios' :
                                                                                'Sin Revisar'}
                                                    </span>
                                                </StyledTableCell>
                                                <StyledTableCell style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                    <div className="action-buttons" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <Link onClick={() => handleClickCarga(row.SolicitudID, row.asignado !== null && row.asignado !== undefined
                                                            ? (users.find(user => user.id === row.asignado)?.nombre || "Usuario no encontrado")
                                                            : "Sin Asignar")} title="Ver Solicitud de Preanálisis" style={{ color: '#10ab80', margin: '0 1px' }}>
                                                            <i className="material-icons">&#xE417;</i>
                                                        </Link>
                                                    </div>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                    ) : (
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={8} style={{ textAlign: 'center' }}>
                                                No se encontraron datos
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {filteredRows.length > 0 && (
                            <TablePagination
                                rowsPerPageOptions={[15, 25, 50]}
                                component="div"
                                count={filteredRows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                labelRowsPerPage={"Filas por página"}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default HistorialPreanalisis;
